import { render } from "./Garantias.vue?vue&type=template&id=321d63f6"
import script from "./Garantias.vue?vue&type=script&lang=js"
export * from "./Garantias.vue?vue&type=script&lang=js"

import "./Garantias.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__